import {
  Spacing
} from 'UI'

export default {
  sideStyle: {
    padding: Spacing(10, 0, 0, 0)
  },
  requirementAndAudience: {
    display: 'flex',
    gap: 43,
    width: '100%'
  },
  pricing: {
    margin: () => Spacing(11, 0, 8, 0)
  }
}
